import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastService } from 'src/app/services/toast/toast.service';
import { WorkflowRuntimeListItem, WorkflowService } from 'src/app/services/workflow/workflow.service';

@Component({
  standalone: false,
  selector: 'app-workflow-exceptions',
  templateUrl: './workflow-exceptions.component.html',
  styleUrls: ['./workflow-exceptions.component.css'],
})
export class WorkflowExceptionsComponent implements OnInit {
  constructor(
    private router: Router,
    private workflowService: WorkflowService,
    public toastService: ToastService,
  ) {}

  exceptions: WorkflowRuntimeListItem[] = [];
  isLoading = false;
  loadError = '';

  ngOnInit(): void {
    this.loadExceptions();
  }

  loadExceptions(): void {
    this.isLoading = true;
    this.loadError = '';
    this.workflowService.getWorkflowExceptions().subscribe({
      next: (items) => {
        this.exceptions = items;
        this.isLoading = false;
      },
      error: () => {
        this.loadError = 'Unable to load items awaiting assignment. Please try again.';
        this.isLoading = false;
      },
    });
  }

  roleLabel(role: string | null): string {
    switch (role) {
      case 'APPROVER_1':
        return 'First Approver';
      case 'APPROVER_2':
        return 'Second Approver';
      case 'INITIATOR':
        return 'Initiator';
      default:
        return role ?? '—';
    }
  }

  back(): void {
    this.router.navigate(['/settings/workflows']);
  }

  assignUser(item: WorkflowRuntimeListItem): void {
    this.router.navigate(['/settings/workflows/build'], {
      state: { workflowTemplateId: item.workflowTemplateId, openRoleAssignment: true },
    });
  }
}
